// removed by extract-text-webpack-plugin
module.exports = {"outer-container":"Tabs__outer-container","outerContainer":"Tabs__outer-container","inner-container":"Tabs__inner-container","innerContainer":"Tabs__inner-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/Tabs.css
// module id = 1263
// module chunks = 8